import { useEffect, useState } from 'react';
import FeedBanner from '../../components/FeedBanner';
import FeedBody from '../../components/FeedBody';
import Footer from '../../components/Footer';
import { Layout } from '../../components/layout';
import { useStream } from '../../contexts/GetStream/StreamContext';
import { choosePlatform, sentryCapture } from '../../helpers/utils';
import { useApi } from '../../hooks/useApi';
import { ChannelTypes, SentryError } from '../../types/enums';

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import DialogFeed from '../../components/DialogFeed';
import FeedPick from '../../components/FeedPick';
import { useFeedUpdateStore } from '../../store/feedUpdate';

export const Feed = () => {
	const api = useApi();
	const { updateFeed, updateFeedFinish } = useStream();
	const { feedupdate, finishUpdateFeed } = useFeedUpdateStore();
	const [feeds, setFeeds] = useState<any>([]);
	const [isLoading, setIsLoading] = useState<any>(false);

	useEffect(() => {
		fetchFeed();
	}, []);

	useEffect(() => {
		if (updateFeed || feedupdate) {
			fetchFeed();
		}
	}, [updateFeed, feedupdate]);

	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			const setupListener = async () => {
				const handle = await App.addListener(
					'appStateChange',
					(appState) => {
						if (appState.isActive) {
							updateFetchFeedBack();
						}
					}
				);
				return handle;
			};

			const listenerPromise = setupListener();
			return () => {
				listenerPromise.then((handle) => handle.remove());
			};
		}
	}, [App]);

	const fetchFeed = async () => {
		setIsLoading(true);
		try {
			const res = await api.getFeed();
			if (!res?.success) {
				throw new Error(res.message);
			}
			setFeeds(res.data);
			finishUpdateFeed();
		} catch (error: any) {
			sentryCapture(error, 'fetchFeed', SentryError.Error);
		} finally {
			setIsLoading(false);
			updateFeedFinish();
		}
	};

	const updateFetchFeedBack = async () => {
		try {
			const res = await api.getFeed();
			if (!res?.success) {
				throw new Error(res.message);
			}
			setFeeds(res.data);
			finishUpdateFeed();
		} catch (error: any) {
			sentryCapture(error, 'fetchFeed', SentryError.Error);
		} finally {
			updateFeedFinish();
		}
	};

	const feedBanner = feeds.filter(
		(feed: any) => feed.channel === ChannelTypes.HOMEHEAD
	);
	const feedBody = feeds.filter(
		(feed: any) => feed.channel === ChannelTypes.HOMEBODY
	);
	return (
		<Layout>
			<div className="w-full lg:max-w-screen-xl lg:mx-auto lg:pt-10 ">
				<div
					className={
						'flex flex-col py-2.5' +
						(choosePlatform() ? ' gap-0.5' : ' gap-3')
					}
				>
					<div className="px-0.5">
						<FeedBanner data={feedBanner} isLoading={isLoading} />
					</div>

					<div className="flex flex-col gap-3 px-0.5">
						{choosePlatform() ? (
							<FeedPick />
						) : (
							<FeedBody data={feedBody} isLoading={isLoading} />
						)}
					</div>
				</div>
			</div>

			<DialogFeed />
			<Footer />
		</Layout>
	);
};
